import { theme } from 'antd';
import type { UseColorResult } from './types';

// 返回antd配置的默认配色
export function usePrimaryColor(opacity = 0.55): UseColorResult {
  const { token } = theme.useToken();
  return {
    hexColor: token.colorPrimary,
    rgbColor: hexToRgb(token.colorPrimary, opacity)
  };
}

function hexToRgb(hex: string, opacity?: number): string {
  // 去掉前缀 #
  const sanitizedHex = hex.replace(/^#/, '');

  // 将 3 位简写形式扩展为 6 位
  const fullHex = sanitizedHex.length === 3
    ? sanitizedHex.split('').map(char => char + char).join('')
    : sanitizedHex;

  // 转换为 RGB
  const rc = parseInt(fullHex.substring(0, 2), 16);
  const gc = parseInt(fullHex.substring(2, 4), 16);
  const bc = parseInt(fullHex.substring(4, 6), 16);

  return `rgba(${rc}, ${gc}, ${bc}, ${opacity ?? 1})`;
}
